export const LoadingScreen = () => (
  <main className="screen screen--centered" aria-busy="true" aria-label="Загрузка">
    <p className="muted">Загрузка…</p>
  </main>
)
